import { AxiosPromise } from 'axios';
import { instance } from '.';
import { URLS } from './index';
import { Logger } from 'fsts';
import { SearchParams } from '../model/searchParams';
import { DefaultBackendHelper } from '../utils/backendHelper';
import admpNews, { AdmpNews, Value } from '../model/admpNews';
import ODataFilterBuilder from 'odata-filter-builder';
import { CONST } from '@/shared/utils/Constants';

export type ContactType = 'member' | 'supplier' | 'intern'; // Member | Supplier | VME-internal

const logger = new Logger('backend.AdmpNews');
export interface BackendAdmpNews {
  getAdmpNews(payload: any): AxiosPromise<AdmpNews>;
  getAdmpNewsList: (searchParams: SearchParams, admpNewsSearchData: any) => AxiosPromise<Value>;
  deleteAdmpNews(id: string): AxiosPromise;
  updateAdmpNews(admpNew: AdmpNews): AxiosPromise<any>;
  uploadNewsDocument(payload: any): AxiosPromise<any>;
  getNewsFileDownloadLink(payload: any): AxiosPromise<any>;
  getNewsCountForUser(payload: any): AxiosPromise<any>;
  upsertAdmpNewsReadInfo(payload: any): AxiosPromise<any>;
  getAdmpNewsFiles(id: number): AxiosPromise<any>;
  updateAdmpNewsFile(payload: any): AxiosPromise<any>;
  deleteAdmpNewsFile(payload: any): AxiosPromise<any>;
  getDashboardAdmpNews(payload: any): AxiosPromise<AdmpNews>;
}

export const defaultBackendAdmpNews: BackendAdmpNews = {
  getAdmpNews(payload: any): AxiosPromise<AdmpNews> {
    return instance.get(`${URLS.admpNews}`, { params: payload });
  },
  getAdmpNewsList(searchParams: SearchParams, admpNewsSearchData: any): AxiosPromise<Value> {
    var odfb = ODataFilterBuilder('and');
    // odfb.eq(CONST.OrganisationId, organisationId, false);
    let url = DefaultBackendHelper.makeUrl(
      `${URLS.admpNewsOdata}`,
      searchParams.dataOption,
      searchParams.orClauseFieldsIds,
      searchParams.filter,
      odfb,
      // [`$expand=news_read_info($filter=user_id eq 'dfc4af64-9a8f-43ea-b8ab-5fb19bbbdecd' )`]
      // [`$expand=news_read_info($select=id;$filter=id eq 1)`]
      [`$expand=news_read_info,news_files`] //&$orderby=news_read_info/is_favorite
    );
    logger.log(`getAdmpNews${url}`);
    console.log('admpNewsSearchData :>> ', admpNewsSearchData);
    return instance.put<Value>(url, admpNewsSearchData);
  },

  deleteAdmpNews(id: string): AxiosPromise {
    logger.debug('deleteAdmpNews');
    return instance.delete(`${URLS.admpNews}/${id}`);
  },
  updateAdmpNews(admpNew: AdmpNews): AxiosPromise<any> {
    logger.debug('updateAdmpNews');
    return instance.put<AdmpNews>(`${URLS.admpNews}/update`, admpNews.toAPI(admpNew));
  },

  uploadNewsDocument(payload: any): AxiosPromise<any> {
    console.log('admpNews uploadDocument payload :>> ', payload);
    return instance.post<any>(`${URLS.admpNews}/postDocument`, payload);
  },
  getNewsFileDownloadLink(payload: any): AxiosPromise<any> {
    console.log('getNewsFileDownloadLink payload ', payload);
    return instance.put<any>(`${URLS.admpNews}/GetFileDownloadLink`, payload, {
      responseType: 'blob',
    });
  },

  getNewsCountForUser(payload: any): AxiosPromise<any> {
    console.log('getNewsCountForUser payload ', payload);
    return instance.put<any>(`${URLS.admpNews}/CountValidAdminNews`, payload);
  },

  upsertAdmpNewsReadInfo(payload: any): AxiosPromise<any> {
    console.log('UpsertAdmpNewsReadInfo payload ', payload);
    return instance.put<any>(`${URLS.admpNews}/UpsertAdmpNewsReadInfo`, payload);
  },

  getAdmpNewsFiles(id: number): AxiosPromise<any> {
    let url = `${URLS.admpNews}/${id}`;
    return instance.get<any>(url);
  },
  updateAdmpNewsFile(payload: any): AxiosPromise {
    logger.debug('updateAdmpNewsFile');
    return instance.put<any>(`${URLS.admpNews}/UpdateAdmpNewsFile`, payload);
  },
  deleteAdmpNewsFile(payload: any): AxiosPromise {
    logger.debug('deleteAdmpNewsFile');
    return instance.put<any>(`${URLS.admpNews}/DeleteAdmpNewsFile`, payload);
  },
  getDashboardAdmpNews(payload: any): AxiosPromise<AdmpNews> {
    return instance.put<any>(`${URLS.admpNews}/GetDashboardAdmpNews`, payload);
  },
};
